import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './../../../../store';
import { useSortBy, useTable, Column } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretSquareUp, faCaretSquareDown } from '@fortawesome/free-solid-svg-icons';
import { FicheroCargaTableModel } from '../../../../types/ranking/ficheroCargaTypes';
import FicheroCargaActions from './FicheroCargaActions';

export default function FicheroCargaTable() {

    const state = useSelector((state: RootState) => state);
    const { content } = state.ranking.ficheroCarga.table;

    // Table

    const columns: Column<FicheroCargaTableModel>[] = React.useMemo(() =>
        [
            {
                Header: 'id',
                accessor: 'id'
            },
            {
                Header: 'Fecha Subida',
                accessor: 'fechaSubida',
                sortType: 'basic',
                Cell: (row: any) => <div style={{ textAlign: "center" }}>{row.value}</div>
            },
            {
                Header: 'Año',
                accessor: 'anio',
                sortType: 'basic',
                Cell: (row: any) => <div style={{ textAlign: "center" }}>{row.value}</div>
            },
            {
                Header: 'Mes',
                accessor: 'mes',
                sortType: 'basic',
                Cell: (row: any) => <div style={{ textAlign: "center" }}>{row.value}</div>
            },
            {
                Header: 'Estado',
                accessor: 'estado',
                sortType: 'basic',
                Cell: (row: any) => <div style={{ textAlign: "center" }}>{row.value}</div>
            },
            {
                Header: 'Acciones',
                Cell: (props: any) => {

                    return <FicheroCargaActions rowContent={props.row.original}/>
                }
            }
        ], []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows
    } = useTable({
        columns,
        data: content,
        autoResetPage: false,
        autoResetSortBy: false,
        initialState: { pageIndex: 0, hiddenColumns: ["id"] },
    }, useSortBy);

    return (
        <table {...getTableProps()} className="table table-striped">
            <thead className="thead-light">
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        {column.render('Header')}
                                        {
                                            <span style={{ float: "right" }}>
                                                {
                                                    column.isSorted ? (column.isSortedDesc ?
                                                        <FontAwesomeIcon icon={faCaretSquareDown} /> :
                                                        <FontAwesomeIcon icon={faCaretSquareUp} />)
                                                        : ''
                                                }
                                            </span>
                                        }
                                    </div>
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
};
